export const defPath = window.drupalSettings ? `${window.drupalSettings.path.themeUrl}/sources-loyalty/dist` : "."

export const fetchPath = window.drupalSettings ? "" : "https://newaguilad9.dp150.xyz"